import {Frontend} from "./frontend";

(function () {
    XonBoard.Sensors = {
        import: function (url) {
            XonBoard.Utils.importFileUsingButton(url);
        },
        list: {

            selectors: {
                sensors_table: $('#sensors-table'),
                count_label: $('#count-label'),
            },

            init: function () {

                let self = this;
                let table = this.selectors.sensors_table.DataTable({
                    bInfo: false,
                    bLengthChange: false,
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: this.selectors.sensors_table.data('ajax_url'),
                        type: 'post',
                        dataSrc(json) {
                            self.updateCount(json.recordsFiltered);
                            return json.data;
                        },
                        data: Frontend.DataTableSearch.globalFilter,
                    },
                    columns: [
                        {
                            data: 'name',
                            name: 'sensors.name',
                            render: (name, type, sensor) => `<span class="name-with-logo">${sensor.logo ?? ''}<span>${name}</span></span>`
                        },
                        {data: 'sensor_type_name', name: 'sensor_types.name', searchable: false,},
                        {data: 'temperature', name: 'sensor_reads.temperature', searchable: false,},
                        {data: 'device_eui', name: 'sensors.device_eui'},
                        {data: 'battery', name: 'sensor_reads.battery', searchable: false,},
                        {data: 'description', name: 'sensors.description'},
                        {data: 'status', name: 'sensors.status', searchable: false,},
                        {data: 'actions', name: 'actions', searchable: false, sortable: false}
                    ],
                    order: [[0, "asc"]],
                    searchDelay: 500,
                    dom: 'lBfrtip',
                    "createdRow": function (row, data, dataIndex) {
                        Frontend.Utils.dtAnchorToForm(row);
                    }
                });

                Frontend.DataTable.init(table);
                Frontend.DataTableSearch.init(table);
                XonBoard.Utils.Select2.init();
            },
            updateCount(total) {
                this.selectors.count_label.text(total);
            },
        },

        create: {
            init: function () {
                XonBoard.Utils.Select2.init();
            },
        },

        edit: {
            selectors: {},

            init: function (locale) {
                this.addHandlers(locale);
                XonBoard.tinyMCE.init(locale);
            },

            addHandlers: function (locale) {
            },
        },
    }
})();
